import { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { observer } from 'mobx-react';
import { SetupTypes } from '../MasterDataPageStore';
import { ClassificationsSetupPage } from './ClassificationsSetupPage';
import { ProTips } from '../../../components/helpers/ProTips';
import { ClassificationsBoardPage } from './ClassificationsBoardPage';
import { RouterPaths } from '../../../router';
import { Route } from 'react-router';
import { ClassificationDetailsPage } from './ClassificationDetailsPage';
import { useStores } from '../../../hooks';
import { RootRoutes } from '../../../router';

export const ClassificationsMappingPage = observer(function ClassificationsMappingPageComponent() {
    // Access nested stores lazily, as the class getters did: test mocks provide only part of
    // the root store, and eager destructuring would throw during render.
    const { domain, ui } = useStores();
    const store = domain.masterDataPageStore;

    useEffect(() => {
        void store.load();

        return () => {
            store.dispose();
        };
    }, [store]);

    const setupClassifications = (setupType) => {
        if (setupType === SetupTypes.OUR_CLASSIFICATIONS) {
            store.useDefaultClassesAndSubclassesAsMaster();
        } else if (setupType === SetupTypes.EXISTING_DATABASE) {
            ui.router.push(RouterPaths.MasterDataPages.MasterDatabaseMappingPage);
        }
    };

    const pageContents = () => {
        const { areClassificationsMapped } = store;

        if (areClassificationsMapped === undefined) {
            return null;
        }

        if (areClassificationsMapped) {
            return (
                <>
                    <RootRoutes>
                        <Route path={RouterPaths.MasterDataPages.ClassificationsMappingCreatePage} element={<ClassificationDetailsPage />} />
                        <Route path={RouterPaths.MasterDataPages.ClassificationsMappingDetailsPage} element={<ClassificationDetailsPage />} />
                    </RootRoutes>
                    <ClassificationsBoardPage />
                </>
            );
        }

        return <ClassificationsSetupPage submit={setupClassifications} />;
    };

    const isLoaded = store.isLoaded;

    return (
        <Container className={'master-data-page'}>
            {!isLoaded && <ProTips />}
            {isLoaded && pageContents()}
        </Container>
    );
});
